import React, {memo} from "react";
import AmountTd from "../../../../Table/Common/AmountTd";

function AmountBase(props) {
    const { record } = props;

    // const companyCurrencyCode = useSelector(state => state.Auth.companyCurrencyCode);

    const { base_amount: amount } = record;
    if (amount === '' || amount === undefined || amount === null)
        return null;

    return (
        <AmountTd amount={amount} doNotReadLists />
    );
}

export default memo(AmountBase);
